// GSAP
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/src/ScrollTrigger';
gsap.registerPlugin( ScrollTrigger );

// Timeline init
let branches_tl = gsap.timeline( { defaults: { repeat: 0, duration: 1} } );

if( $('body').hasClass('branches-page') ) {

    // // Tween 1: Cards fade-in down
    // branches_tl.from( 
    //     $('#vision-mission .card'), 
    //     {
    //         // scrollTrigger: {
    //         //     trigger: '#vision-mission .card',
    //         //     start: "0% 100%",
    //         //     end: "80% 80%",
    //         //     scrub: 2,
    //         // },
    //         autoAlpha: 0,
    //         stagger: 0.5,
    //         yPercent: -50,
    //         duration: 1,
    //         delay: 0.5,
    //         ease: 'back.out(1.2)',
    //     },
        
    // );
}
        